import { render, staticRenderFns } from "./TaskSearchBar.vue?vue&type=template&id=6951b704&"
import script from "./TaskSearchBar.vue?vue&type=script&lang=ts&"
export * from "./TaskSearchBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports